import Header from '../../components/Header'
import Footer from '../../components/Footer'

import { useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'

import pagamento from '../../api/pagamento'
import MySavedCards from '../../components/MyPaymentCards'
import DeleteCardModal from '../../components/MyPaymentCards/DeleteCardModal'
import FormAddNewCreditCard from '../../components/MyPaymentCards/FormAddNewCreditCard'

import Loader from '../../components/Loader'
import * as S from '../../styles/page-profile'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { useLocation } from 'react-router-dom'

function MeusCartoes() {
  const [current, setCurrent] = useState(1)

  const [showModal, setShowModal] = useState(false)
  const [cardId, setCardId] = useState('')
  const [userCards, setUserCards] = useState([])
  const [loading, setLoading] = useState(false)

  const openModal = (id) => {
    setShowModal((prev) => !prev)
    setCardId(id)
  }

  async function getSavedCards() {
    setLoading(true)
    await pagamento
      .getCartoes()
      .then((response) => {
        setLoading(false)
        return response.json()
      })
      .then((obj) => setUserCards(obj))
      .catch((err) => {
        if (err) setLoading(false)
      })
  }

  const location = useLocation()

  useEffect(() => {
    getLocalStorageLog(location.pathname)
  }, [])

  useEffect(() => {
    getSavedCards()
  }, [current])

  // console.log(userCards)

  return (
    <S.Main>
      <DeleteCardModal
        showModal={showModal}
        setShowModal={setShowModal}
        current={current}
        setCurrent={setCurrent}
        cardId={cardId}
        setLoading={setLoading}
      />

      <Header />

      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Meus métodos de pagamento</BreadcrumbItem>
                  {current === 2 && (
                    <BreadcrumbItem>Adicionar Cartão</BreadcrumbItem>
                  )}
                </Breadcrumb>

                {current === 1 || current === 3 ? (
                  <>
                    {!!loading ? (
                      <Loader />
                    ) : (
                      <MySavedCards
                        cardData={userCards}
                        deleteModal={openModal}
                        setCardId={setCardId}
                        loading={loading}
                        setCurrent={setCurrent}
                      />
                    )}
                  </>
                ) : null}

                {current === 2 && (
                  <FormAddNewCreditCard
                    setCurrent={setCurrent}
                    current={current}
                  />
                )}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>

      <Footer />
    </S.Main>
  )
}

export default MeusCartoes
